export default function init(run) {
  const state = document.readyState;
  if (state === 'complete' || state === 'interactive') {
    return run();
  }
  if (window.addEventListener) {
    window.addEventListener('DOMContentLoaded', run);
  } else {
    window.attachEvent('onload', run);
  }
}



// WEBPACK FOOTER //
// ./pages/.initializer.js